module.exports = __webpack_public_path__ + "img/photo-0011.8865c92b.jpg";